import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {ModelEditComponent} from '../../components/DomainDataEdit/ModelEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-Model-grid',
  templateUrl: './ModelGrid.component.html'
})
export class ModelGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(ModelEditComponent) recordEditComponent: ModelEditComponent;

    userInfo: ent.UserInfo;
    records: ent.Model[];
    selectedRecords: ent.Model[] = [];
    editedRecord: ent.Model;

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.Model();
        this.recordEditComponent.modelGroupDropdown.load();
        this.onSearchClick(null);
    }

    onSearchClick(event: any){
        var filter: filters.ModelFilter = {IncludeInactive: true};
        this.domainDataService.getModels(filter).subscribe(x=>{this.records = x});
    }

    onAddClick(event: any){
        this.editedRecord = new ent.Model();
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, model: ent.Model){
        this.editedRecord = model;
        this.recordEditComponent.modelGroupDropdown.value = model.ModelGroupID;
        this.recordEditComponent.equipmentGraphicsMultiSelect.selectedIDs = [];

        if (model.EquipmentGraphics){
            for (var eg of model.EquipmentGraphics){
                this.recordEditComponent.equipmentGraphicsMultiSelect.selectedIDs.push(eg.ID);
            }
        }

        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        this.editedRecord.EquipmentGraphics = [];
        for (var id of this.recordEditComponent.equipmentGraphicsMultiSelect.selectedIDs){
            this.editedRecord.EquipmentGraphics.push({ID: id, Inactive: false});
        }
        var request: ent.SaveModelRequest = {Model: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveModel(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
}